module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-002"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }), _c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HARACTERS IN THE")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAMA")])])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Caius Flavius "), _c('b', [_vm._v("Amyntas")]), _vm._v(", a Christian and wealthy landowner, grandson of a freedman")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Tiberius Claudius "), _c('b', [_vm._v("Aristion")]), _vm._v(", high priest and temple warden of the Temple of the Sebastoi")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_vm._v("Burrhus")]), _vm._v(", a Christian in Amyntas’s house church")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_vm._v("Chreste")]), _vm._v(", the eleven-year-old daughter of Demetrius and Olympias")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Flavia "), _c('b', [_vm._v("Chrysanthe")]), _vm._v(", Amyntas’s wife")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("T. Julius Damas "), _c('b', [_vm._v("Claudianus")]), _vm._v(", a member of "), _c('i', [_vm._v("koinon")]), _vm._v(" (the provincial council) of Asia and president of the civic council of Ephesus")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_vm._v("Demetrius")]), _vm._v(", son of Apollonius, a Christian merchant and host to a house church")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_vm._v("Diodotos")]), _vm._v(", an outspoken Christian artisan and member of Amyntas’s house church")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_vm._v("Euplus")]), _vm._v(", a Christian slave in Serapion’s house")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_vm._v("Fronto")]), _vm._v(", a Christian in Amyntas’s house church")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Publius Aurelius "), _c('b', [_vm._v("Hippicus")]), _vm._v(", son of Serapion and Isidora")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Aurelia "), _c('b', [_vm._v("Isidora")]), _vm._v(", Serapion’s wife")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_vm._v("Menes")]), _vm._v(", a slave in the household of Amyntas")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Titus Flavius "), _c('b', [_vm._v("Montanus")]), _vm._v(", eventually to be associated with the titles “high priest of Asia’s shared temple in Ephesos, "), _c('i', [_vm._v("sebastophant")]), _vm._v(", and "), _c('i', [_vm._v("agonothete")]), _vm._v(" for life” in Ephesus")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }), _c('b', [_vm._v("Nicolaus")]), _vm._v(", son of Strato, of Pergamum, a Christian and junior priest of the Provincial Temple of Augustus and Roma in Pergamum")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_vm._v("Olympias")]), _vm._v(", Demetrius’s wife")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_vm._v("Parmenon")]), _vm._v(", the steward in Serapion’s household")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_vm._v("Prochorus")]), _vm._v(" of Smyrna, a Christian and a disciple of John the Seer, assisting him in his exile on Patmos")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Aulus Julius "), _c('b', [_vm._v("Quadratus")]), _vm._v(" of Pergamum, who would become proconsul of Asia in 108/109—now chief of staff of the proconsul of Asia, Marcus Gillo")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Gaius Vibius "), _c('b', [_vm._v("Salutaris")]), _vm._v(", a local benefactor")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Caius Flavius "), _c('b', [_vm._v("Secundus")]), _vm._v(", son of Amyntas and Chrysanthe")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Publius Aurelius "), _c('b', [_vm._v("Serapion")]), _vm._v(", a wealthy landowner and a priest of Artemis")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_vm._v("Theon")]), _vm._v(", the eight-year-old son of Demetrius and Olympias")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_vm._v("Trophimus")]), _vm._v(", a onetime associate of Paul, an elder among the Ephesian churches")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Flavia "), _c('b', [_vm._v("Tryphaina")]), _vm._v(", daughter of Amyntas and Chrysanthe")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Titus Flavius "), _c('b', [_vm._v("Zeuxis")]), _vm._v(", a successful sea captain and merchant, an imperial freedman, and a Jew")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c33bd820","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/pre3.vue
// module id = 69
// module chunks = 0